import React, { useEffect, useMemo, useState } from 'react';

const decodeEscapedUnicode = (value = '') =>
  value
    .replace(/\\u\{([0-9a-fA-F]{1,6})\}/g, (match, hex) => {
      const codePoint = Number.parseInt(hex, 16);
      return Number.isNaN(codePoint) ? match : String.fromCodePoint(codePoint);
    })
    .replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
      const codePoint = Number.parseInt(hex, 16);
      return Number.isNaN(codePoint) ? match : String.fromCharCode(codePoint);
    });

const ContentRenderer = ({ index, htmlContent, conversation_id, isLatestMessage, IsStreamApi }) => {
  const [imageUrls, setImageUrls] = useState([]);
  const [coversation, setConversation] = useState(null);
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(isLatestMessage);
  const normalizedHtmlContent = useMemo(() => decodeEscapedUnicode(htmlContent || ''), [htmlContent]);

  const stripHtmlTags = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  };

  useEffect(() => {
    const plainText = stripHtmlTags(normalizedHtmlContent);
    // Otherwise just show full content immediately
    setDisplayedText(plainText);
    setIsTyping(false);
  }, [normalizedHtmlContent, isLatestMessage, IsStreamApi]);


  // Reset images when conversation_id changes
  useEffect(() => {
    if (conversation_id?.id !== coversation) {
      setImageUrls([]); // Reset image list
      setConversation(conversation_id?.id);
    }
  }, [conversation_id?.id]); // Run only when conversation_id.id changes

  useEffect(() => {
    // Function to handle anchor tag clicks
    const handleAnchorClick = (event) => {
      event.preventDefault();
      const url = event.target.href;
      window.open(url, '_blank');
    };

    // Get all anchor tags within the rendered HTML
    const anchors = document.querySelectorAll('.markDownSetting a');
    anchors.forEach((anchor) => {
      anchor.addEventListener('click', handleAnchorClick);
    });

    // Search for all anchor tags with href attributes containing .png or .jpg
    const anchorTags = normalizedHtmlContent.match(/<a[^>]+href="([^">]+)"/g);

    if (anchorTags) {
      const urls = anchorTags
        .map((tag) => {
          const match = tag.match(/href="([^">]+)"/);
          return match ? match[1] : null;
        })
        .filter(Boolean)
        .filter((url) => url.endsWith('.png') || url.endsWith('.jpg'));

      setImageUrls(urls);
    }

    // Cleanup event listeners on component unmount
    return () => {
      anchors.forEach((anchor) => {
        anchor.removeEventListener('click', handleAnchorClick);
      });
    };
  }, [normalizedHtmlContent]);

  return (
    <div>
      {/* Render the content */}
      <span id={`id_${index}`} className="markDownSetting">
        {isTyping ? (
          <p className="whitespace-pre-wrap font-mono text-gray-700">
            {displayedText}
            <span className="animate-pulse">|</span>
          </p>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: normalizedHtmlContent }} />
        )}
      </span>

      {/* Render images found in the anchor tags */}
      {imageUrls.length > 0 && (
        <div style={{ marginTop: '20px' }}>
          {imageUrls.map((url, idx) => (
            <img key={idx} src={url} alt={`Content Image ${idx}`} style={{ width: '200px', height: 'auto' }} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ContentRenderer;
